import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Cart from './cart'
import Browse from './browse'
import { CartProvider} from 'react-use-cart'
import Success from './Success'
import Landing from './landing'
import Qrcode from './qrCode'
import History from './history'
import Idle from './Idle'
import Game from './game'

function Menu() {
    return (
           <Router>
               <Routes>
                <Route path='/' element={<Landing/>}/>
                <Route path='/table/:tableid' element={<Landing/>}/>
                <Route path='/Browse' element={<CartProvider><Browse/></CartProvider>}/>
                <Route path='/cart' element={<CartProvider><Cart/></CartProvider>}/>
                <Route path='/success' element={<Success/>}/>
                <Route path='/qr' element={<Qrcode/>}/>
                <Route path='/History' element={<History/>}/>
                <Route path='/idle' element={<Idle/>}/>
                <Route path='/game' element={<Game/>}/>
               </Routes>
           </Router>
    )
}

export default Menu
